import { Component, Inject, LOCALE_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { GetAllBuildingMarkers } from './shared/ngxs/action/building.action';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(
    private translateService: TranslateService,
    @Inject(LOCALE_ID) protected localeId: string,
    private store: Store
  ) {
    translateService.addLangs(['en', 'mk']);
    translateService.setDefaultLang('mk');

    // On first start add building markers in cache
    this.store.dispatch(new GetAllBuildingMarkers());
  }
}
